import { Message } from '../message';
import { TransportBase } from './Transport';
import { ignore } from 'utility/ignore';

export async function sendRequest(
    url: string,
    transaction: string,
    command: string,
    body = {}
) {
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            ...body,
            janus: command,
            transaction,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return await res.json();
}

export type HttpTransportConfig = {
    maxev?: number;
};

export class HttpTransport extends TransportBase {
    private readonly maxev: number;

    constructor(private readonly server: string, config: HttpTransportConfig) {
        super();

        this.server = server;

        this.maxev = config.maxev ?? 5;
    }

    protected _startSubscribing(sessionId: number) {
        this._startLongPolling(sessionId, this.maxev, msg => {
            if (msg.janus === 'keepalive') return;
            this._onmessage(msg);
        });
    }

    async _startLongPolling(
        sessionId: number,
        maxev: number,
        onmessage: (msg: Message) => void
    ) {
        const url =
            this.server +
            '/' +
            sessionId +
            '?rid=' +
            new Date().getTime() +
            '&maxev=' +
            maxev;

        for (; ;) {
            const res = await fetch(url, {
                method: 'GET',
            });
            const messages: Message | Message[] = await res.json();

            if (Array.isArray(messages)) {
                for (const msg of messages) {
                    onmessage(msg);
                }
            } else {
                onmessage(messages);
            }
        }
    }

    async keepalive(sessionId: number) {
        ignore(sessionId);
        // nothing to do because of the nature of long polling
    }

    protected async _sendMessage(
        tx: string,
        command: string,
        sessionId: number,
        handleId: number | undefined,
        body?: object
    ) {
        const url = [this.server, sessionId, handleId]
            .filter(s => s !== '')
            .join('/');
        const msg = await sendRequest(url, tx, command, body);
        this._onmessage(msg);
    }
}
